import { render, staticRenderFns } from "./setAttachment.vue?vue&type=template&id=c5ba948a&scoped=true&"
import script from "./setAttachment.vue?vue&type=script&lang=js&"
export * from "./setAttachment.vue?vue&type=script&lang=js&"
import style0 from "./setAttachment.vue?vue&type=style&index=0&id=c5ba948a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba948a",
  null
  
)

export default component.exports